import React, { useEffect, useState } from 'react';
import { MdEmail, MdClose } from 'react-icons/md';
import { AiOutlineCalendar, AiOutlineClockCircle } from 'react-icons/ai';
import { FiPaperclip, FiDownload, FiEdit } from 'react-icons/fi';
import { IoPersonCircle } from "react-icons/io5";
import { LuPrinter } from "react-icons/lu";
import { FiExternalLink } from "react-icons/fi";
import { BiPaperclip } from "react-icons/bi";
import { FaRegStar, FaFilePdf, FaFileWord, FaFileExcel, FaFileImage, FaFileAudio, FaFileVideo, FaFileArchive, FaFileAlt, FaFile } from "react-icons/fa";
import { FiSmile } from "react-icons/fi";
import { PiArrowBendUpLeftBold } from "react-icons/pi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { getOutlookMessageDetails, getGmailMessageDetails, getOutlookEmailDetailsFromDB, getGmailEmailDetailsFromDB, API_URL } from "../../services/api";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import toast from 'react-hot-toast';
import { DataState } from "../../context/DataProvider";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";
import { FiMaximize, FiMinimize } from "react-icons/fi";
import AIEmailView from "./AIEmailView";
import { Link } from 'react-router-dom';
import EmailIframe from './EmailIframe';
import {getFileIcon} from "./AttachmentIcon"


// const getFileIcon = (mimeType) => {
//   if (mimeType?.includes("pdf")) return <FaFilePdf className="text-red-500" size={20} />;
//   if (mimeType?.includes("word")) return <FaFileWord className="text-[#5652CF]" size={20} />;
//   if (mimeType?.includes("excel")) return <FaFileExcel className="text-green-500" size={20} />;
//   if (mimeType?.includes("image")) return <FaFileImage className="text-yellow-500" size={20} />;
//   if (mimeType?.includes("zip") || mimeType?.includes("rar")) return <FaFileArchive className="text-gray-500" size={20} />;
//   if (mimeType?.includes("audio")) return <FaFileAudio className="text-purple-500" size={20} />;
//   if (mimeType?.includes("video")) return <FaFileVideo className="text-indigo-500" size={20} />;
//   return <FaFile className="text-gray-500" size={20} />;
// };

const handleDownload = async (messageId, attachmentId, fileName, accessToken, isOutlook) => {
  try {
    // Make a GET request to the FastAPI endpoint with the access_token in Authorization header
    let response = null;
    if (isOutlook) {
      response = await fetch(`${API_URL}/email/outlook/${messageId}/download-attachment/${attachmentId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,  // Adding Bearer token in the header
        },
        credentials: "include"
      });

      if (!response.ok) {
        throw new Error('Failed to fetch attachment');
      }


    } else {
      response = await fetch(`${API_URL}/email/gmail/${messageId}/download-attachment/${attachmentId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,  // Adding Bearer token in the header
        },
        credentials: "include"
      });

      if (!response.ok) {
        throw new Error('Failed to fetch attachment');
      }
    }


    // The file is streamed as a Blob
    const blob = await response.blob();  // Convert the streamed content to Blob

    // Create an object URL for the Blob to trigger the download
    const url = window.URL.createObjectURL(blob);
    // Create an anchor element and programmatically click to trigger download
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;  // Customize the filename
    document.body.appendChild(link);  // Append link to the body (required for Firefox)
    link.click();
    document.body.removeChild(link);  // Clean up link after download
    window.URL.revokeObjectURL(url);  // Revoke the URL to free memory
    toast.success("Download Successful:", fileName)
  } catch (error) {
    console.error('Error downloading file:', error);
    // toast.error(JSON.stringify(error))
    toast.error(typeof error === "string" ? error : (error?.message || error?.detail || "Download Failed"));
  }
};


const AttachmentItem = ({ messageId, attachment, isOutlook }) => {
  const {
    userGoogleId
  } = DataState();
  const [hovered, setHovered] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const handleDownloadClick = async () => {
    if (isDownloading) return; // Prevent double clicks
    setIsDownloading(true);

    try {
      await handleDownload(
        messageId,
        attachment.attachmentId,
        attachment.filename,
        userGoogleId,
        isOutlook
      );
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setIsDownloading(false); // Reset downloading state
    }
  };

  return (
    <div
      className="text-gray-500 w-40 h-10 py-3 border p-2 rounded-lg shadow-md cursor-pointer inline-flex items-center justify-center"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >

      {hovered ? (
        <div className="flex gap-4 items-center justify-center w-full">
          {isDownloading ? (
            <AiOutlineLoading3Quarters className="text-gray-600 animate-spin" size={16} />
          ) : (
            <FiDownload
              onClick={handleDownloadClick}
              className="text-gray-600 cursor-pointer hover:text-black"
              size={16}
            />
          )}

          <FiPaperclip className="text-gray-600 cursor-pointer hover:text-black" size={16} />
          <FiEdit className="text-gray-600 cursor-pointer hover:text-black" size={16} />
        </div>
      ) : (
        <div className="flex items-center space-x-2 w-full">
          <div className="w-8 h-8 flex items-center justify-center">
            {getFileIcon(attachment.filename)} {/* Handle both cases */}
          </div>
          <span className="truncate text-sm font-medium">
            {attachment.filename || attachment.name} {/* Handle both cases */}
          </span>
        </div>
      )}

    </div>
  );
};

function convertToIST(dateString) {
  // Parse the date string into a Date object (in UTC)
  const dateUTC = new Date(dateString);

  // Format the date to "28 Jan, 2025"
  const formattedDate = dateUTC.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  // Format the time to "7:20 AM"
  const formattedTime = dateUTC.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return { date: formattedDate, time: formattedTime };
}

function parseEmailList(emailString) {
  const emailObjects = emailString.split(/,\s*/).map(entry => {
    // Match cases with quotes for the email: `"email@example.com" <email@example.com>`
    const quotedEmailMatch = entry.match(/^"([^"]+)"\s*<([^>]+)>$/);
    if (quotedEmailMatch) {
      const email = quotedEmailMatch[2];
      return { name: quotedEmailMatch[1], email };
    }


    // Match cases with name and email: `Name <email@example.com>`
    const nameEmailMatch = entry.match(/^(.+?)\s*<([^>]+)>$/);
    if (nameEmailMatch) {
      const name = nameEmailMatch[1].trim();
      const email = nameEmailMatch[2].trim();
      return { name, email };
    }


    return { name: entry.trim(), email: entry.trim() }; // Handle unexpected formats gracefully
  }).filter(Boolean); // Remove invalid entries

  return emailObjects;
}


const emailData = {
  from: 'Ashneet Kaur',
  fromemail: 'asheetkaur@gmail.com',
  to: 'Halo sr',
  subject: 'Application for Python Developer Intern Position',
  date: 'Dec 20, 2021',
  time: '5:47 PM',
  content: `
    Good Evening,

    I hope this email finds you well. My name is Ashneet Kaur, a B.Tech Computer Science and Engineering student, graduating in 2025. I am excited to apply for the Python Developer Intern position at your esteemed organization.

    With hands-on experience in Python and Flask, I have built dynamic backend systems, integrated RESTful APIs, and ensured seamless application functionality. My expertise in MongoDB for efficient data management, combined with deploying cloud-ready applications on AWS, has
    equipped me to deliver scalable solutions. Additionally, I have implemented secure authentication mechanisms and leveraged GitHub for version control in collaborative projects.

    Here's how my skills align with your requirements:

    * Backend Development: Proficient in Python and Flask for robust application development.
    * Database Management: Skilled in designing and optimizing MongoDB databases.
    * API Integration: Experienced in creating and connecting RESTful APIs effectively.
    * Cloud Deployment: Hands-on experience deploying scalable solutions on AWS.
    * Collaboration Tools: Adept at version control and team collaboration using GitHub.

    I am inspired by your organization's commitment to fostering innovation and excellence. Joining your team would not only allow me to contribute meaningfully but also enable me to grow as a developer in a dynamic environment.

    I have attached my resume for your review and would be delighted to discuss how my skills align with your team's goals. Thank you for considering my application. I look forward to the opportunity to contribute and learn from your expertise.

    Warm regards,
    Ashneet Kaur
    7668431481
  `,
  attachments: [{ name: 'Scanned by Gmail' }],
};

const SkeletonLoader = ({ type = 'text' }) => {
  if (type === 'text') {
    return (
      <div className="mr-4 space-y-4">
        <div className="w-full h-6 bg-gray-300 animate-pulse rounded"></div>
        <div className="w-3/4 h-6 bg-gray-300 animate-pulse rounded"></div>
        <div className="w-1/2 h-6 bg-gray-300 animate-pulse rounded"></div>
      </div>
    );
  }
  if (type === 'emailbody') {
    return (
      <div className="mr-4 space-y-4">
        <div className="w-full h-6 bg-gray-300 animate-pulse rounded"></div>
        <div className="w-3/4 h-6 bg-gray-300 animate-pulse rounded"></div>
        <div className="w-1/2 h-6 bg-gray-300 animate-pulse rounded"></div>
        <div className="w-3/4 h-6 bg-gray-300 animate-pulse rounded"></div>
        <div className="w-1/2 h-6 bg-gray-300 animate-pulse rounded"></div>
        <div className="w-3/4 h-6 bg-gray-300 animate-pulse rounded"></div>
        <div className="w-1/2 h-6 bg-gray-300 animate-pulse rounded"></div>
      </div>
    );
  }

  if (type === 'image') {
    return (
      <div className="mr-4 w-full h-48 bg-gray-300 animate-pulse rounded-lg"></div>
    );
  }

  if (type === 'card') {
    return (
      <div className="mr-4 w-full max-w-sm bg-white shadow-md rounded-lg p-4 space-y-4">
        <div className="w-full h-32 bg-gray-300 animate-pulse rounded-lg"></div>
        <div className="h-6 bg-gray-300 animate-pulse rounded"></div>
        <div className="h-6 w-3/4 bg-gray-300 animate-pulse rounded"></div>
      </div>
    );
  }

  return null;
};

const EmailComponent = ({ messageId, analytics, onClose, isOutlook }) => {
  const [isAnalyticsView, setIsAnalyticsView] = useState(false);
  const [email, setEmail] = useState({});
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showAIViewButton, setShowAIViewButton] = useState(false);


  const [showAll, setShowAll] = useState(false);
  const visibleCount = 3;

  const {
    userGoogleId
  } = DataState();

  useEffect(() => {
    const setMessageDetails = async () => {
      if (!messageId) {
        return;
      }

      try {
        let message_data = null;
        let fromDB = true;

        // Try fetching from DB
        try {

          if (isOutlook) {
            message_data = await getOutlookEmailDetailsFromDB(messageId, userGoogleId);
          } else {
            message_data = await getGmailEmailDetailsFromDB(messageId, userGoogleId);
          }

          setShowAIViewButton(true); // Found in DB → show AI View
        } catch (err) {
          console.log("Error fetching from database:", err)
          //If not found in DB (404), fallback to API
            fromDB = false;
            setShowAIViewButton(false); // Not in DB → hide AI View

            if (isOutlook) {
              message_data = await getOutlookMessageDetails(messageId, userGoogleId);
            } else {
              message_data = await getGmailMessageDetails(messageId, userGoogleId);
            }

        }



        if (fromDB) {
          message_data.snippet = message_data.body_preview || "";
          message_data.subject = message_data.subject || "No Subject";
          message_data.body = message_data.body || "";
          message_data.date = message_data.date || message_data.created_date_time;
          message_data.from = [ // convert sender to array
            {
              name: message_data.sender?.name || "",
              email: message_data.sender?.contact || ""
            }
          ];
          message_data.to = (message_data.recipients || []).map(to => ({
            name: to.name,
            email: to.contact
          }));
          message_data.attachments = message_data.attachments || [];
          if (isOutlook){
            message_data.attachments = (message_data.attachments || []).map(attachment => {
              return { ...attachment, mimeType: attachment.contentType, attachmentId: attachment.id, filename: attachment.name }
            })
          }
        } else {
          if (isOutlook) {
            message_data.from.email = message_data.from?.address;
            message_data.from = [message_data.from]
            message_data.to = message_data.to?.map(to => {
              return { ...to, email: to.address }
            })
            message_data.attachments = (message_data.attachments || []).map(attachment => {
              return { ...attachment, mimeType: attachment.contentType, attachmentId: attachment.id, filename: attachment.name }
            })
          } else if (!isOutlook) {
            // 🌟 Parse Gmail format
            message_data.snippet = message_data.snippet || "";
            message_data.body = message_data.body || "";
            message_data.from = parseEmailList(message_data.from);
            message_data.to = parseEmailList(message_data.to);
          }
        }


        const { time, date } = convertToIST(message_data.date);
        message_data.time = time;
        message_data.date = date;
        
        setEmail(message_data)
        setLoading(false)


      } catch (error) {
        toast.error(error);
        setLoading(false);
      }
    }
    setMessageDetails();


  }, [messageId, userGoogleId, isOutlook]);

  const toggleView = () => {
    setIsAnalyticsView(!isAnalyticsView);
  };


  return (
    <div
      className="fixed inset-0 max-md:p-2 flex items-center justify-center bg-black bg-opacity-50 z-100"
      onClick={onClose}
    >
      <div
        className="flex md:flex-col bg-gray-100 p-4 w-full max-md:h-full md:min-h-[300px] md:w-2/3 rounded-lg md:shadow-md"
        onClick={(e) => e.stopPropagation()}
      >

        <div className="flex flex-row md:mt-4 w-full">
          <div className="hidden md:block px-4 pl-0">
            <IoPersonCircle className="text-gray-700" size={40} />
          </div>
          <div className="flex flex-col h-full w-full">
            <div className="flex flex-col md:flex-row md:items-center justify-between mb-2 w-full">

              {loading ? (
                <div className="w-full md:w-96 h-6 bg-gray-300 animate-pulse rounded mb-2 md:mb-0" />
              ) : (
                <h2 className="text-gray-900  text-lg md:text-xl font-semibold mb-2 md:mb-0">
                  {isAnalyticsView ? "Email Analytics" : email.subject || "No Subject"}
                </h2>

              )
              }
              <div className={` flex flex-wrap items-center ${showAIViewButton ? "max-md:justify-between" : "max-md:justify-end" } gap-2 md:gap-4 md:mr-4 `}>
                { showAIViewButton && <button
                  className={`px-3 py-1 text-sm text-white rounded flex items-center justify-center transition ${loading ? "h-6 w-14 bg-gray-300 animate-pulse" : "bg-zinc-500 hover:bg-zinc-600"
                    }`}
                  onClick={toggleView}
                  disabled={loading}
                >
                  {loading ? "" : isAnalyticsView ? "View Email" : "AI View"}
                </button> }

                <div className="flex items-center gap-2">

                  {/* {loading ? (
                    <div className="w-6 h-6 bg-gray-300 rounded animate-pulse"></div>
                  ) : (
                    <button className="text-gray-500 hover:text-gray-700">
                      <LuPrinter size={20} />
                    </button>
                  )} */}

                  {loading ? (
                    <div className="w-6 h-6 bg-gray-300 rounded animate-pulse"></div>
                  ) : (
                    <Link
                      target="_blank"
                      to={isOutlook ? email?.webLink : `https://mail.google.com/mail/u/0/#all/${messageId}`}
                    >
                      <button className="text-gray-500 hover:text-gray-700">
                        <FiExternalLink size={20} />
                      </button>
                    </Link>
                  )}

                  <button
                    className="text-gray-500 hover:text-gray-700"
                    onClick={() => {
                      setIsAnalyticsView(false);
                      onClose();
                    }}
                  >
                    <MdClose size={20} />
                  </button>
                </div>

              </div>
            </div>
            <div className="flex flex-col md:flex-row items-center justify-between">
              <div className="flex text-gray-700 md:items-center max-md:w-full  mb-4">

                <div className={`md:hidden px-4 pl-0 rounded ${loading && "text-gray-800 animate-pulse"}`}>
                  <div className={`w-10 h-10  text-white flex items-center justify-center rounded-full text-sm font-bold ${loading ? "bg-gray-300" : "bg-gray-700"}`}>
                    {email.from?.map((from, index) => {
                      return (
                        <span key={index}>
                          {from.name[0].toUpperCase()}
                        </span>
                      )
                    })}
                  </div>
                </div>

                <div className="flex flex-col">
                  {email.from?.map((from, index) => {
                    return (<span key={index} className="font-semibold">
                      {from.name} <span className="font-normal text-sm text-gray-500">{from.email || "No Sender"}</span>
                    </span>)
                  })}

                  <div className="flex">
                    {!loading && <span className="text-gray-500 mr-2"> to  </span>}
                    <div className="flex items-center">
                      {email.to?.slice(0, visibleCount).map((to, index) => (
                        <span
                          key={index}
                          className="font-semibold"
                          title={to?.email || "No Recipient"}
                        >
                          {to?.name || to?.email || "No Recipient"}
                          {index < Math.min(visibleCount, email.to?.length) - 1 && ", "}
                        </span>
                      ))}

                      {/* Toggle button to expand/collapse extra recipients */}
                      {email.to?.length > visibleCount && (
                        <button
                          className="ml-1 text-[#5652CF] hover:underline flex items-center"
                          onClick={() => setShowAll(!showAll)}
                        >
                          {showAll ? "show less" : `+${email.to?.length - visibleCount}`}
                          {showAll ? <HiChevronUp size={14} /> : <HiChevronDown size={14} />}
                        </button>
                      )}
                    </div>

                    {/* Extra emails, smoothly expanding below */}
                    <div
                      className={`border border-gray-400 p-2 rounded-xl transition-all duration-300 ease-in-out text-gray-500 font-semibold ${showAll ? "max-h-40 opacity-100" : "max-h-0 opacity-0 overflow-hidden"
                        }`}
                    >
                      {email.to?.slice(visibleCount).map((to, index) => (
                        <span key={index} className="block text-sm text-gray-700">
                          {to.name || to.email || "No Recipient"}
                        </span>
                      ))}
                    </div>
                  </div>

                </div>
              </div>
              <div className="flex max-md:w-full max-md:justify-between gap-2 text-sm md:mr-4">

                <div className="flex gap-2">
                  <div className="flex gap-2 items-center mb-4">

                    {!loading ? (
                      <span className="text-gray-500 text-sm">{email.date || ""}</span>
                    ) : (<div className="w-3/4 h-3 bg-gray-500 animate-pulse rounded"></div>)}
                  </div>
                  <div className="flex items-center mb-4">
                    {!loading ? (
                      <span className="text-gray-500 text-sm">{email.time || ""}</span>
                    ) : (<div className="w-3/4 h-3 bg-gray-300 animate-pulse rounded"></div>)}
                  </div>
                </div>

                {/* <div className="flex gap-2">
                  <button
                    className="text-gray-500 hover:text-gray-700 mb-4"
                  >
                    <FaRegStar />
                  </button>
                  <button
                    className="text-gray-500 hover:text-gray-700 mb-4"
                  >
                    <FiSmile />
                  </button>
                  <button
                    className="text-gray-500 hover:text-gray-700 mb-4"
                  >
                    <PiArrowBendUpLeftBold />
                  </button>
                  <button
                    className="text-gray-500 hover:text-gray-700 mb-4"
                  >
                    <BsThreeDotsVertical />
                  </button>
                </div> */}
              </div>
            </div>
            {isAnalyticsView ? (

              <AIEmailView email={email} />
            ) : (
              <div className="relative">
                {!loading && (
                  <button
                    className="absolute bottom-2 right-10 bg-gray-200 text-gray-500 hover:bg-gray-300 hover:text-gray-700 p-2 rounded-full transition-all transform hover:scale-110"
                    onClick={() => setIsFullScreen(true)}
                  >
                    <FiMaximize size={20} />
                  </button>
                )}
                {loading ? (
                  <div className='pr-10'>
                    <SkeletonLoader type="emailbody" />
                  </div>
                ) : (
                  // <article
                  //   // dangerouslySetInnerHTML={{ __html: email.body }}
                  //   className="text-gray-700 mr-4 whitespace-pre-line max-h-96 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-200 [&_*]:m-0 [&_*]:p-0"
                  // > {/* </article> */}
                  <div className="flex-1 max-h-96 overflow-y-auto">
                    <EmailIframe emailBody={email.body}></EmailIframe>

                  </div>

                )}
              </div>
            )
            }
            <div className="mt-4">
              <div className="flex items-center mb-2 border-t border-gray-300 pl-0 p-4">
                <FiPaperclip className="text-gray-500 mr-2" size={20} />
                <span className="text-gray-500">Attachments</span>
              </div>
              {email.attachments && email.attachments.length > 0 && (

                <div className="flex flex-wrap items-center gap-2  p-1 flex-grow min-h-[40px]">
                  {email.attachments.map((att) => (
                    <AttachmentItem
                      key={att.attachmentId}
                      messageId={messageId}
                      attachment={att}
                      isOutlook={isOutlook}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

      </div>

      {
        isFullScreen && (
          <div className="fixed inset-0 w-screen h-screen bg-white z-50 p-6">
            {/* Close button stays fixed at top-right */}
            <button
              className="absolute bottom-8 right-14 bg-gray-200 text-gray-500 hover:bg-gray-300 hover:text-gray-700 p-2 rounded-full transition-all transform hover:scale-110"
              onClick={() => setIsFullScreen(false)}
            >
              <FiMinimize size={24} />
            </button>

            {/* Scrollable content */}
            <div className="overflow-auto h-full scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-200">
              {/* <article
                dangerouslySetInnerHTML={{ __html: email.body }}
                className="text-gray-700 whitespace-pre-line"
              /> */}
              <EmailIframe emailBody={email.body}></EmailIframe>
            </div>
          </div>
        )
      }
    </div >
  );
};


export default EmailComponent;